export const spinnerTextDefaultStyle = (theme, size) => ({
  overflow: 'hidden',
  color: `${theme.tokens.ComponentSpinnerTextColor}`,
  textAlign: 'center',
  textOverflow: 'ellipsis',
  fontFamily: `${theme.tokens.SemTypeFontBody}`,
  fontSize: size === 'large' ? '22px' : '16px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '125%',
  textTransform: 'capitalize',
  whiteSpace: 'nowrap',
  width: 'fill-available'
});
export const spinnerLightDefaultStyle = (theme, size, fullScreen) => ({
  backgroundColor: !fullScreen ? `${theme.tokens.ComponentSpinnerLightColor}` : '',
  borderRadius: !fullScreen ? '4px' : '',
  boxShadow: !fullScreen ? `0px 0px 6px 0px ${theme.tokens.ComponentSpinnerOverlayColor}` : '',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  minWidth: size === 'large' ? '180px' : '110px',
  maxWidth: size === 'large' ? '400px' : '280px',
  padding: size === 'large' ? '32px' : '16px',
  gap: '16px',
  width: size === 'large' ? '400px' : '280px'
});